import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastComponent } from '@webapp/ui';

@Component({
  imports: [RouterModule, ToastComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
